import styled, { css } from 'styled-components';
import { getTextPresetCss } from '@optimus-web/common';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    Component,
    Decision,
    getComponentToken,
    Spacing,
    SPACING,
    TEXT_PRESET_KEY,
} from '@optimus-web/local-tokens';
import { BareIconButton } from '../BareIconButton';

const getAccordionColorToken = getComponentToken(Component.Accordion);

export const AccordionContainerElement = styled.div`
    text-align: left;
`;

export const AccordionHeaderElement = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${SPACING[200]}px;
    padding: ${SPACING[100]}px ${SPACING[200]}px;
    background-color: ${getAccordionColorToken(Decision.BackgroundColor)};
    border-bottom: 1px solid ${getAccordionColorToken(Decision.BorderColor)};
    cursor: pointer;
`;

export const AccordionHeaderLeftElement = styled.div`
    display: flex;
    cursor: default;
    align-items: center;
    gap: ${SPACING[200]}px;
`;

export const AccordionHeaderLabelElement = styled.div`
    display: flex;
    gap: ${SPACING[200]}px;
    align-items: center;
    flex: 1;
    flex-wrap: wrap;
`;

export const AccordionPrimaryTextElement = styled.div`
    ${getTextPresetCss(TEXT_PRESET_KEY['200m'])};
    color: ${getAccordionColorToken(Decision.Color)};
`;

export const AccordionSecondaryTextElement = styled.div`
    ${getTextPresetCss(TEXT_PRESET_KEY['100r'])};
    color: ${getAccordionColorToken(Decision.Color, { variant: 'secondary' })};
`;

export const AccordionHeaderRightElement = styled.div`
    display: flex;
    cursor: default;
    align-items: center;
`;
export interface AccordionIconProps {
    expanded: boolean;
}

export const AccordionIconButtonElement = styled(BareIconButton)<AccordionIconProps>`
    & > span {
        transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'none')};
        transition-timing-function: ${ANIMATION_CURVE.default};
        transition-duration: ${ANIMATION_DURATION.fast}ms;
    }
`;

export interface AccordionBodyProps {
    bodyPadding: Spacing;
    withBodyBorder?: boolean;
}
const borderBottomCss = css`
    border-bottom: 1px solid ${getAccordionColorToken(Decision.BorderColor)};
`;
export const AccordionBodyElement = styled.div<AccordionBodyProps>`
    background-color: ${getAccordionColorToken(Decision.BackgroundColor)};
    ${(props) => `padding: ${SPACING[props.bodyPadding]}px;`}
    ${(props) => (props.withBodyBorder ? borderBottomCss : '')}
`;
